import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import videojs from 'video.js';

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PlayerComponent implements OnInit, OnDestroy,OnChanges {
  @ViewChild('target', {static: true}) target: ElementRef;
  @Input('master') signedURL: '';
  @Input('fileName') fileName: '';
   // see options: https://github.com/videojs/video.js/blob/mastertutorial-options.html
   @Input() options: {
     controls:boolean,
     fill: boolean,
 
    playbackRates: number [],
    responsive:boolean,
    autoplay: boolean,
    sources: {
        src: string,
        type: string,
    }[],
};
player: videojs.Player;
constructor(
  private elementRef: ElementRef,
) { }


ngOnChanges()
{
    console.log(JSON.stringify(this.signedURL))
    console.log("GOT THAT")
    console.log(this.fileName)
    let mimeType=''
    let videoFormat=this.fileName.substr(this.fileName.length - 3).toLowerCase();
    // if(videoFormat=="wmv")
    // {
    //   mimeType='video/x-ms-wmv'
    // } obsolete wont play in modern browsers
    if(videoFormat=='mp4')
    {
      mimeType='video/mp4'
    }
    if(videoFormat=='avi')
    {
      mimeType='video/x-msvideo'
    }
    if(videoFormat=='m4v')
    {
      mimeType='video/x-m4v'
    } 
   
    if( this.signedURL!==undefined ){
    
         // this.player.reset()
         console.log("final mime is")
         console.log(mimeType)
          this.options={ autoplay: true,
            playbackRates: [ 1, 1.5, 2],
          
           fill:true,
             controls: true,
             responsive:true,
            
              sources: [{ src: this.signedURL, type: mimeType }]
            }
          //this.options.sources=[{src:r['url_signed'],type:'video/mp4'}]
          // instantiate Video.js
          this.player = videojs(this.target.nativeElement, this.options, function onPlayerReady() {
            console.log('onPlayerReady', this);
          });
         

    
    }

}

ngOnInit() {
  // console.log("COMPONENT PLAYER BORN");
  
  // this.options={ autoplay: true,fluid:true, controls: true, sources: [{ src: this.signedURL, type: 'video/mp4' }]}
  // //this.options.sources=[{src:r['url_signed'],type:'video/mp4'}]
  // // instantiate Video.js
  // this.player = videojs(this.target.nativeElement, this.options, function onPlayerReady() {
  //   console.log('onPlayerReady', this);
  // });
}

ngOnDestroy() {
  // destroy player
  if (this.player) {
    this.player.dispose();
  }
}

}

